<template>
  <div
    class="m-base-root"
    :class="{
      'm-base-top-border':showTopBorder,
      'm-base-right-border':showRightBorder,
      'm-base-bottom-border':showBottomBorder,
      'm-base-left-border':showLeftBorder}"
  >
    <slot name="box">
      <div
        class="m-base-box"
        :class="{
        'm-base-padding':showPadding,
				'm-base-block':boxType=='block',
				'm-base-card':boxType=='card',
				'm-base-border-radius':showBorderRadius
				}"
        :style="{
          backgroundColor:backgroundColor,
          paddingLeft:showLeftPadding?'10px':'0px',
          paddingRight:showRightPadding?'10px':'0px',
          paddingTop:showTopPadding?'10px':'0px',
          paddingBottom:showBottomPadding?'10px':'0px'
        }"
      >
        <div v-if="showHeader" @click="onMore" class="d-flex flex-row align-items-center">
          <van-image lazy-load v-if="icon&&showIcon" class="m-base-icon" :src="icon" />
          <div class="m-base-tit-box">
            <span class="m-base-tit">{{title}}</span>
            <span v-if="subTitle" class="m-base-tit2">{{subTitle}}</span>
          </div>
          <span v-if="showMore" class="yticon icon-you"></span>
        </div>
        <slot name="content"></slot>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'm-base',
  props: {
    //是否显示下边框
    showTopBorder: {
      type: Boolean,
      default: false
    },
    //是否显示下边框
    showRightBorder: {
      type: Boolean,
      default: false
    },
    //是否显示下边框
    showBottomBorder: {
      type: Boolean,
      default: true
    },
    //是否显示下边框
    showLeftBorder: {
      type: Boolean,
      default: false
    },
    //容器样式类型：block(块), card(卡片)
    boxType: {
      type: String,
      default: 'block'
    },
    //是否显示圆角
    showBorderRadius: {
      type: Boolean,
      default: false
    },
    showPadding: {
      type: Boolean,
      default: true
    },
    showLeftPadding: {
      type: Boolean,
      default: true
    },
    showRightPadding: {
      type: Boolean,
      default: true
    },
    showTopPadding: {
      type: Boolean,
      default: true
    },
    showBottomPadding: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: 'rgba(255,255,255,1)'
    },
    //是否显示顶栏
    showHeader: {
      type: Boolean,
      default: true
    },
    //图标
    icon: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    //主标题
    title: {
      type: String,
      default: '主标题'
    },
    //副标题
    subTitle: {
      type: String,
      default: ''
    },
    //是否显示更多
    showMore: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {

    };
  },
  methods: {
    onMore () {
      if (this.showMore) {
        this.$emit('onClickMore')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-base-box {
  // background-color: white;
}

.m-base-block {
  // padding: 34upx;
}
.m-base-padding {
  padding: 12px;
}
.m-base-padding-t-0 {
  padding: 0 12px 12px 12px;
}
.m-base-card {
  // padding: 24upx;
  margin: 0upx 5px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.m-base-top-border {
  padding-top: 10px;
}
.m-base-right-border {
  padding-right: 10px;
}
.m-base-bottom-border {
  padding-bottom: 10px;
}
.m-base-left-border {
  padding-left: 10px;
}

.m-base-border-radius {
  border-radius: 12px;
  overflow: hidden;
}

.m-base-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.m-base-tit-box {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.m-base-tit {
  font-size: $uni-font-size-lg + 1px;
  color: $font-color-dark;
  line-height: 1.3;
}

.m-base-tit2 {
  font-size: $uni-font-size-sm;
  color: $font-color-light;
}

.m-base-icon-you {
  font-size: $uni-font-size-lg + 1px;
  color: $font-color-light;
}
</style>
